import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  messageTemplateData,
  templateData,
  listMessageTemplateData,
  addMessageTemplateEntry,
  removeMessageTemplateEntry,
  setTitleData,
  setPhoneMessageData,
  setSMSMessageData,
  setEmailMessageData,
  setLanguageData,
  setEnglishPositiveResponseData,
  setEnglishNegativeResponseData,
  setSpanishPositiveResponseData,
  setSpanishNegativeResponseData,
} from '../../store/MessageTemplate/actionCreator'
import {
  CircularProgress,
  TextField,
  Button,
  Typography,
  ListItem,
  ListItemText,
  Box,
  Tooltip,
} from '@material-ui/core'
import HeaderTitle from '../Header/HeaderTitle'
import { Helmet } from 'react-helmet'
import WarningIcon from '@material-ui/icons/Warning'
import { withStyles } from '@material-ui/core/styles'
import { formValidation } from '../MessageCreate/formValidation'
import MessageCreateForm from '../MessageCreate/MessageCreateForm'
import LanguageSwitch from '../Language/LanguageSwitch'
import MessageTemplateItems from '../MessageTemplate/MessageTemplateItems'
import PropTypes, {
  string,
  shape,
  arrayOf,
  bool,
  func,
  object,
} from 'prop-types'

const styles = (theme) => ({
  spinner: {
    color: theme.palette.primary.main,
  },
  homePage: {
    textAlign: 'center',
  },
  centerDiv: {
    margin: 'auto',
    padding: '0px',
    width: '20%',
    minWidth: 475,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  centerListText: {
    margin: 'auto',
    minWidth: '250px',
    maxWidth: '50%',
    padding: '10px',
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
})

export class MessageTemplateMaintenancePage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      messageTemplateAddEntry: '',
      messageTemplateAddEntryError: true,
      blossomID: this.props.blossomIDFromParent,
      validData: false,
      titleFromChild: true,
      phoneMessageFromChild: true,
      smsMessageFromChild: true,
      emailMessageFromChild: true,
      validMessage: false,
      titleDataFromChild: null,
      phoneMessageDataFromChild: '',
      smsMessageDataFromChild: '',
      emailMessageDataFromChild: '',
      contactDataFromChild: [
        {
          id: 1,
          text: 'Phone',
          checked: true,
        },
        {
          id: 2,
          text: 'SMS',
          checked: true,
        },
        {
          id: 3,
          text: 'Email',
          checked: true,
        },
      ],
      notifyDataFromChild: false,
      languageDataFromChild: false,
      englishPositiveResponseFromChild: true,
      englishNegativeResponseFromChild: true,
      spanishPositiveResponseFromChild: true,
      spanishNegativeResponseFromChild: true,
      englishPositiveResponseDataFromChild: '',
      englishNegativeResponseDataFromChild: '',
      spanishPositiveResponseDataFromChild: '',
      spanishNegativeResponseDataFromChild: '',
      validContactData: true,
      showMessagePage: false,
      messageID: null,
    }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    const target = event.target
    const name = target.name
    const value = target.value

    this.setState({
      [name]: value,
    })

    if (name === 'messageTemplateAddEntry') {
      if (formValidation(value, 'text', 'boolean') === false) {
        this.setState({
          messageTemplateAddEntryError: false,
        })
      } else {
        this.setState({
          messageTemplateAddEntryError: true,
        })
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { location, blossomIDFromParent, listMessageTemplateData } =
      this.props
    const {
      titleFromChild,
      phoneMessageFromChild,
      smsMessageFromChild,
      emailMessageFromChild,
    } = this.state
    const { location: prevLocation } = prevProps
    // method to see if the reports need to be refreshed
    if (
      location &&
      prevLocation &&
      prevLocation.pathname &&
      location.pathname &&
      prevLocation.pathname !== location.pathname
    ) {
      this.setState({ blossomID: blossomIDFromParent })
      listMessageTemplateData(blossomIDFromParent)
    }
    if (
      prevState.titleFromChild !== titleFromChild ||
      prevState.phoneMessageFromChild !== phoneMessageFromChild ||
      prevState.smsMessageFromChild !== smsMessageFromChild ||
      prevState.emailMessageFromChild !== emailMessageFromChild
    ) {
      this.setState({
        validMessage: this.enableSubmit(
          titleFromChild,
          phoneMessageFromChild,
          smsMessageFromChild,
          emailMessageFromChild,
        ),
      })
    }
  }

  componentDidMount() {
    this.setMessageTemplateData()
  }

  enableSubmit(isTitleEmpty, isPhoneEmpty, isSMSEmpty, isEmailEmpty) {
    var enableSubmit = false
    if (!isTitleEmpty && (!isPhoneEmpty || !isSMSEmpty || !isEmailEmpty)) {
      enableSubmit = true
    }
    return enableSubmit
  }

  setMessageTemplateData() {
    this.props.listMessageTemplateData(this.state.blossomID)
  }

  removeMessageTemplateEntry = (value) => {
    this.props.removeMessageTemplateEntry(this.state.blossomID, value)
  }

  addMessageTemplateEntry = (value) => {
    // update method open message page first, then add to message template entry, pass in message title as value

    this.setState({
      titleDataFromChild: value,
      showMessagePage: true,
    })
    this.titleCallback(formValidation(value, 'text', 'boolean'))
  }

  updateMessageTemplateEntry = (value) => {
    // update method open message page first, then add to message template entry,
    this.setState({
      titleDataFromChild: value.original['message_title'],
      messageID: value.original['pk_id'],
      phoneMessageDataFromChild: value.original['message_body_phone'],
      smsMessageDataFromChild: value.original['message_body_sms'],
      emailMessageDataFromChild: value.original['message_body_email'],
      englishPositiveResponseDataFromChild:
        value.original['message_response_positive'],
      englishNegativeResponseDataFromChild:
        value.original['message_response_negative'],
      spanishPositiveResponseDataFromChild:
        value.original['message_response_positive_es'],
      spanishNegativeResponseDataFromChild:
        value.original['message_response_negative_es'],
      showMessagePage: true,
      validMessage: false,
    })

    this.titleCallback(
      formValidation(value.original['message_title'], 'text', 'boolean'),
    )
    this.phoneMessageCallback(
      formValidation(value.original['message_body_phone'], 'text', 'boolean'),
    )
    this.smsMessageCallback(
      formValidation(value.original['message_body_sms'], 'text', 'boolean'),
    )
    this.emailMessageCallback(
      formValidation(value.original['message_body_email'], 'text', 'boolean'),
    )
  }

  submitMessageTemplateEntry = () => {
    const {
      blossomID,
      titleDataFromChild,
      phoneMessageDataFromChild,
      smsMessageDataFromChild,
      emailMessageDataFromChild,
      englishPositiveResponseDataFromChild,
      englishNegativeResponseDataFromChild,
      spanishPositiveResponseDataFromChild,
      spanishNegativeResponseDataFromChild,
      messageID,
    } = this.state
    this.props.addMessageTemplateEntry(
      blossomID,
      titleDataFromChild,
      phoneMessageDataFromChild,
      smsMessageDataFromChild,
      emailMessageDataFromChild,
      englishPositiveResponseDataFromChild,
      englishNegativeResponseDataFromChild,
      spanishPositiveResponseDataFromChild,
      spanishNegativeResponseDataFromChild,
      messageID,
    )

    // Manually input data for testing if needed
    // this.props.addMessageTemplateEntry(this.state.blossomID, this.state.titleDataFromChild, 'Test Phone', 'Test SMS', 'Test Email',
    // 'English Yes', 'English No', 'Spanish Yes', 'Spanish No', null)
    this.handleReset()
  }

  static defaultProps = {}

  handleReset = () => {
    this.setState({
      messageTemplateAddEntry: '',
      titleDataFromChild: null,
      phoneMessageDataFromChild: '',
      smsMessageDataFromChild: '',
      emailMessageDataFromChild: '',
      englishPositiveResponseDataFromChild: '',
      englishNegativeResponseDataFromChild: '',
      spanishPositiveResponseDataFromChild: '',
      spanishNegativeResponseDataFromChild: '',
      phoneMessageFromChild: true,
      smsMessageFromChild: true,
      emailMessageFromChild: true,
      englishPositiveResponseFromChild: true,
      englishNegativeResponseFromChild: true,
      spanishPositiveResponseFromChild: true,
      spanishNegativeResponseFromChild: true,
      messageID: null,
      languageDataFromChild: false,
      messageTemplateAddEntryError: true,
      showMessagePage: false,
    })
    this.props.setTitleData('')
    this.props.setPhoneMessageData('')
    this.props.setSMSMessageData('')
    this.props.setEmailMessageData('')
    this.props.setEnglishPositiveResponseData('')
    this.props.setEnglishNegativeResponseData('')
    this.props.setSpanishPositiveResponseData('')
    this.props.setSpanishNegativeResponseData('')
    this.props.setLanguageData(true)
  }

  titleCallback = (dataFromChild) => {
    this.setState({ titleFromChild: dataFromChild })
  }
  phoneMessageCallback = (dataFromChild) => {
    this.setState({ phoneMessageFromChild: dataFromChild })
  }
  smsMessageCallback = (dataFromChild) => {
    this.setState({ smsMessageFromChild: dataFromChild })
  }
  emailMessageCallback = (dataFromChild) => {
    this.setState({ emailMessageFromChild: dataFromChild })
  }
  englishPositiveResponseCallback = (dataFromChild) => {
    this.setState({ englishPositiveResponseFromChild: dataFromChild })
  }
  englishNegativeResponseCallback = (dataFromChild) => {
    this.setState({ englishNegativeResponseFromChild: dataFromChild })
  }
  spanishPositiveResponseCallback = (dataFromChild) => {
    this.setState({ spanishPositiveResponseFromChild: dataFromChild })
  }
  spanishNegativeResponseCallback = (dataFromChild) => {
    this.setState({ spanishNegativeResponseFromChild: dataFromChild })
  }
  titleDataCallback = (dataFromChild) => {
    this.setState({ titleDataFromChild: dataFromChild })
    this.props.setTitleData(dataFromChild)
  }
  phoneMessageDataCallback = (dataFromChild) => {
    this.setState({ phoneMessageDataFromChild: dataFromChild })
    this.props.setPhoneMessageData(dataFromChild)
  }
  smsMessageDataCallback = (dataFromChild) => {
    this.setState({ smsMessageDataFromChild: dataFromChild })
    this.props.setSMSMessageData(dataFromChild)
  }
  emailMessageDataCallback = (dataFromChild) => {
    this.setState({ emailMessageDataFromChild: dataFromChild })
    this.props.setEmailMessageData(dataFromChild)
  }
  englishPositiveResponseDataCallback = (dataFromChild) => {
    this.setState({ englishPositiveResponseDataFromChild: dataFromChild })
    this.props.setEnglishPositiveResponseData(dataFromChild)
  }
  englishNegativeResponseDataCallback = (dataFromChild) => {
    this.setState({ englishNegativeResponseDataFromChild: dataFromChild })
    this.props.setEnglishNegativeResponseData(dataFromChild)
  }
  spanishPositiveResponseDataCallback = (dataFromChild) => {
    this.setState({ spanishPositiveResponseDataFromChild: dataFromChild })
    this.props.setSpanishPositiveResponseData(dataFromChild)
  }
  spanishNegativeResponseDataCallback = (dataFromChild) => {
    this.setState({ spanishNegativeResponseDataFromChild: dataFromChild })
    this.props.setSpanishNegativeResponseData(dataFromChild)
  }
  contactDataCallback = (dataFromChild) => {
    this.setState({ contactDataFromChild: dataFromChild })
    this.props.setContactData(dataFromChild)
  }
  notifyDataCallback = (dataFromChild) => {
    this.setState({ notifyDataFromChild: dataFromChild })
    this.props.setNotifyData(dataFromChild)
  }
  contactDataCallbackValid = (dataFromChild) => {
    this.setState({ validContactData: dataFromChild })
  }
  languageDataCallback = (dataFromChild) => {
    this.setState({ languageDataFromChild: dataFromChild })
    this.props.setLanguageData(dataFromChild)
  }

  getTotalSMSCharacters(
    smsMessageData,
    englishOnly,
    englishPositiveResponseData,
    englishNegativeResponseData,
    spanishPositiveResponseData,
    spanishNegativeResponseData,
  ) {
    let characterLength = smsMessageData.length
    // If Responses enabled, include length of 2 shorturls (23 each) + 6 newlines + 2 spaces + 'Msg & data rates may apply' (28) = 82
    if (
      englishPositiveResponseData !== '' ||
      englishNegativeResponseData !== ''
    ) {
      characterLength +=
        englishPositiveResponseData.length +
        englishNegativeResponseData.length +
        82
    }
    if (
      englishOnly === false &&
      (spanishPositiveResponseData !== '' || spanishNegativeResponseData !== '')
    ) {
      // If Spanish responses also enabled, add length of 2 shorturls (23 each) + 4 newlines + 2 spaces = 52
      characterLength +=
        spanishPositiveResponseData.length +
        spanishNegativeResponseData.length +
        52
    }
    return characterLength
  }

  render() {
    const { classes, headerTitle, responseData, fetchingState } = this.props
    const {
      validMessage,
      blossomID,
      showMessagePage,
      titleDataFromChild,
      contactDataFromChild,
      phoneMessageDataFromChild,
      smsMessageDataFromChild,
      emailMessageDataFromChild,
      languageDataFromChild,
      notifyDataFromChild,
      englishPositiveResponseDataFromChild,
      englishNegativeResponseDataFromChild,
      spanishPositiveResponseDataFromChild,
      spanishNegativeResponseDataFromChild,
      messageTemplateAddEntry,
      messageTemplateAddEntryError,
    } = this.state

    let groupTitle = ''
    let tableData = ''
    if (blossomID === 'bcp') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - BCP Message Template Maintenance" />
      )
    } else if (blossomID === 'c3alert') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - C3 Message Template Maintenance" />
      )
    } else if (blossomID === 'ceebackup') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - CEE Backup Message Template Maintenance" />
      )
    } else if (blossomID === 'fmocdc') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - FMOC DC Message Template Maintenance" />
      )
    } else if (blossomID === 'precall') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - Product Recall Message Template Maintenance" />
      )
    } else if (blossomID === 'CI00598283') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - HR Message Template Maintenance" />
      )
    } else if (blossomID === 'c3aalert') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - C3A Message Template Maintenance" />
      )
    } else if (blossomID === 'developer') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - Developer Message Template Maintenance" />
      )
    } else if (blossomID === 'shipt') {
      groupTitle = (
        <HeaderTitle title="TgtAlerts - Shipt Message Template Maintenance" />
      )
    }

    if (responseData === '') {
      tableData = 'No data found in TOM Database'
    } else {
      tableData = (
        <MessageTemplateItems
          blossomIDFromParent={blossomID}
          dataFromParent={responseData}
          callbackFromParentUpdateData={this.updateMessageTemplateEntry}
          callbackFromParentDeleteData={this.removeMessageTemplateEntry}
          fetchingState={fetchingState}
        />
      )
    }

    let messagePage = ''
    let languagePage = ''
    let titleLanguage = ''

    if (showMessagePage) {
      messagePage = (
        <MessageCreateForm
          callbackFromParentTitle={this.titleCallback}
          callbackFromParentTitleData={this.titleDataCallback}
          callbackFromParentPhoneMessage={this.phoneMessageCallback}
          callbackFromParentPhoneMessageData={this.phoneMessageDataCallback}
          callbackFromParentSMSMessage={this.smsMessageCallback}
          callbackFromParentSMSMessageData={this.smsMessageDataCallback}
          callbackFromParentEmailMessage={this.emailMessageCallback}
          callbackFromParentEmailMessageData={this.emailMessageDataCallback}
          fromParentTitleData={titleDataFromChild}
          fromParentContactMethods={contactDataFromChild}
          fromParentPhoneMessageData={phoneMessageDataFromChild}
          fromParentSMSMessageData={smsMessageDataFromChild}
          fromParentEmailMessageData={emailMessageDataFromChild}
          fromParentIsTemplate={true}
        />
      )
      titleLanguage = (
        <Typography component="span" variant="body2">
          Language to send on Responses
        </Typography>
      )
      languagePage = (
        <LanguageSwitch
          className={classes.centerListSmall}
          callbackFromParentLanguage={this.languageDataCallback}
          languageFromParent={languageDataFromChild}
          callbackFromParentEnglishPositiveResponse={
            this.englishPositiveResponseCallback
          }
          callbackFromParentEnglishPositiveResponseData={
            this.englishPositiveResponseDataCallback
          }
          callbackFromParentEnglishNegativeResponse={
            this.englishNegativeResponseCallback
          }
          callbackFromParentEnglishNegativeResponseData={
            this.englishNegativeResponseDataCallback
          }
          callbackFromParentSpanishPositiveResponse={
            this.spanishPositiveResponseCallback
          }
          callbackFromParentSpanishPositiveResponseData={
            this.spanishPositiveResponseDataCallback
          }
          callbackFromParentSpanishNegativeResponse={
            this.spanishNegativeResponseCallback
          }
          callbackFromParentSpanishNegativeResponseData={
            this.spanishNegativeResponseDataCallback
          }
          fromParentNotify={notifyDataFromChild}
          fromParentLanguageSelected={languageDataFromChild}
          fromParentEnglishPositiveResponseData={
            englishPositiveResponseDataFromChild
          }
          fromParentEnglishNegativeResponseData={
            englishNegativeResponseDataFromChild
          }
          fromParentSpanishPositiveResponseData={
            spanishPositiveResponseDataFromChild
          }
          fromParentSpanishNegativeResponseData={
            spanishNegativeResponseDataFromChild
          }
        />
      )
    }
    // Create variables from values of matching keys
    let toRender = <br />
    let totalSMSCharacters = this.getTotalSMSCharacters(
      smsMessageDataFromChild,
      languageDataFromChild,
      englishPositiveResponseDataFromChild,
      englishNegativeResponseDataFromChild,
      spanishPositiveResponseDataFromChild,
      spanishNegativeResponseDataFromChild,
    )
    let characterCountString =
      'Total characters used for SMS message: ' +
      String(totalSMSCharacters) +
      '/320'
    if (
      englishPositiveResponseDataFromChild !== '' ||
      englishNegativeResponseDataFromChild !== ''
    ) {
      characterCountString += ' (includes response URLs and text)'
    }
    let smsCharacterCount = (
      <Box color="text.primary">
        <ListItem className={classes.centerListText}>
          <ListItemText primary={characterCountString} />
        </ListItem>
      </Box>
    )
    if (totalSMSCharacters > 160 && totalSMSCharacters <= 320) {
      smsCharacterCount = (
        <Box color="warning.main">
          <ListItem className={classes.centerListText}>
            <ListItemText primary={characterCountString} />
            <Tooltip title="Messages over 160 characters may be split into more than one SMS">
              <WarningIcon />
            </Tooltip>
          </ListItem>
        </Box>
      )
    } else if (totalSMSCharacters > 320) {
      smsCharacterCount = (
        <Box color="warning.main">
          <ListItem className={classes.centerListText}>
            <ListItemText primary={characterCountString} />
            <Tooltip
              title="SMS messages must be less than 320 characters to submit campaign"
              aria-label="error"
            >
              <WarningIcon />
            </Tooltip>
          </ListItem>
        </Box>
      )
    }

    if (fetchingState === false && responseData == null) {
      toRender = <br />
    } else if (fetchingState === true) {
      toRender = (
        <div>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>loading...</h3>
        </div>
      )
    } else if (responseData != null) {
      toRender = (
        <div className={classes.centerDiv}>
          {showMessagePage && (
            <div>
              <Button
                onClick={() => {
                  this.handleReset()
                }}
                variant="contained"
                className={classes.button}
              >
                Back
              </Button>
              {messagePage}
              {titleLanguage}
              {languagePage}
              <Button
                disabled={!validMessage}
                onClick={() => {
                  this.submitMessageTemplateEntry()
                }}
                variant="contained"
                className={classes.button}
              >
                Send to Message Template Table
              </Button>
              {smsCharacterCount}
            </div>
          )}
          {showMessagePage || (
            <div>
              <TextField
                id="filled-message-template-input"
                label="Enter Template Name"
                className={classes.textField}
                // type="messageTemplate"
                name="messageTemplateAddEntry"
                // margin="normal"
                // variant="filled"
                InputLabelProps={{
                  shrink: true,
                }}
                value={messageTemplateAddEntry}
                onChange={this.handleChange.bind(this)}
                error={messageTemplateAddEntryError}
                inputProps={{ maxLength: 50 }}
              />
              <Button
                disabled={messageTemplateAddEntryError}
                onClick={() => {
                  this.addMessageTemplateEntry(messageTemplateAddEntry)
                }}
                variant="contained"
                className={classes.button}
              >
                Create New Message Template
              </Button>
              <br />
              {tableData}
            </div>
          )}
        </div>
      )
    }

    return (
      <div className={classes.myBox}>
        {groupTitle}
        <Helmet>
          <title>{headerTitle}</title>
        </Helmet>
        <div className={classes.homePage}>
          <br />
          {toRender}
        </div>
      </div>
    )
  }
}

MessageTemplateMaintenancePage.propTypes = {
  blossomID: PropTypes.string.isRequired,
  listMessageTemplateData: PropTypes.func.isRequired,
  responseData: PropTypes.array,
  fetchingState: PropTypes.bool,
}

const mapStateToProps = (state) => ({
  messageTemplateAddEntry: state.templateData.inputAddEntryData,
  responseData: state.templateData.data,
  fetchingState: state.templateData.fetching,
  fetching2State: state.templateData.fetching2,
  titleDataFromChild: state.templateData.inputTitleData,
  phoneMessageDataFromChild: state.templateData.inputPhoneMessageData,
  smsMessageDataFromChild: state.templateData.inputSMSMessageData,
  emailMessageDataFromChild: state.templateData.inputEmailMessageData,
  languageDataFromChild: state.templateData.inputLanguageData,
  englishPositiveResponseDataFromChild:
    state.templateData.inputEnglishPositiveResponseData,
  englishNegativeResponseDataFromChild:
    state.templateData.inputEnglishNegativeResponseData,
  spanishPositiveResponseDataFromChild:
    state.templateData.inputSpanishPositiveResponseData,
  spanishNegativeResponseDataFromChild:
    state.templateData.inputSpanishNegativeResponseData,
  headerTitle: state.headerTitle,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      messageTemplateData,
      templateData,
      listMessageTemplateData,
      addMessageTemplateEntry,
      removeMessageTemplateEntry,
      setTitleData,
      setPhoneMessageData,
      setSMSMessageData,
      setEmailMessageData,
      setLanguageData,
      setEnglishPositiveResponseData,
      setEnglishNegativeResponseData,
      setSpanishPositiveResponseData,
      setSpanishNegativeResponseData,
    },
    dispatch,
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(MessageTemplateMaintenancePage))

MessageTemplateMaintenancePage.propTypes = {
  blossomIDFromParent: string,
  classes: object,
  headerTitle: string,
  responseData: arrayOf(
    shape({
      message_title: string,
    }),
  ),
  listMessageTemplateData: func,
  removeMessageTemplateEntry: func,
  addMessageTemplateEntry: func,
  setTitleData: func,
  setPhoneMessageData: func,
  setSMSMessageData: func,
  setEmailMessageData: func,
  setEnglishPositiveResponseData: func,
  setEnglishNegativeResponseData: func,
  setSpanishPositiveResponseData: func,
  setSpanishNegativeResponseData: func,
  setContactData: func,
  setNotifyData: func,
  setLanguageData: func,
  fetchingState: bool,
}
